import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

import { GetterTypes, MutationTypes } from "@/store";
import { LayoutTypes } from "@/store/app/state";
import { useComputedValue } from "@/composables";
import { useRoute, useRouter } from "vue-router";
import Icon from "@/components/icons/Icon/Icon.vue";
import { IconType } from "@/types/icons";
import { useStore } from "vuex";


export default /*#__PURE__*/_defineComponent({
  __name: 'MobileNavigationBackButton',
  setup(__props) {

const route = useRoute();
const router = useRouter();
const layoutType = useComputedValue<LayoutTypes>(GetterTypes.GET_LAYOUT_TYPE);
const { commit } = useStore();

const returnBack = () => {
  if (route.path === "/") {
    return;
  }

  commit(MutationTypes.CLEAR_CHATS_FILTER);
  router.replace("/");
};

return (_ctx: any,_cache: any) => {
  return (_unref(layoutType) === _unref(LayoutTypes).MOBILE)
    ? (_openBlock(), _createElementBlock("button", {
        key: 0,
        onClick: returnBack
      }, [
        _createVNode(Icon, {
          icon: _unref(IconType).BACK
        }, null, 8, ["icon"])
      ]))
    : _createCommentVNode("", true)
}
}

})